/** value == database path */
export enum IssueType {
  DEFECT = 'defect',
  ISSUE = 'residentIssue',
  CONCIERGE = 'concierge'
}

export enum IssueStatus {
  NOTICED = 'noticed',
  IN_PROGRESS = 'in_progress',
  FIXED = 'fixed',
  CANCELLED = 'cancelled',
  /** accepted repair ~ archived */
  ACCEPTED = 'accepted',
  NONE = 'none'
}

/** values misinforming, due to compatibility */
export enum Payer {
  RESIDENT = 'landlord',
  ESTATE = 'tenant'
}

export enum IssuePriority {
  LOW = 'low',
  MEDIUM = 'mid',
  HIGH = 'high'
}

export interface IssueBase extends IssueMedia {
  id: string;
  estateId: string;

  userId: string | null;
  residentId: string | null;
  adminId: string | null;

  /** assigned estateAdmin userId */
  assignedUserId: string | null;
  /** estateAdmin assign date - do not confuse with assignmentDate */
  assignedUserDate: number | null;

  /** @optional set only from web; resident phone number */
  phone: string | null;

  title: string;
  /** Human-Readable reference id, added on backend */
  refId: string | null;
  /** more like create date */
  date: number;
  description: string;

  status: IssueStatus;
  priority?: IssuePriority | undefined;
  dataStatusChange: number | null;

  estimatedRepairDate: number | null;
  closeDate: number | null;
  estimatedPricing: number | null;
  finalPricing: number | null;
  payer: Payer | null;
  /**
   * @defect reported to subcontractor;
   * @issue @task confirmed to resident
   */
  isReportToFix: boolean | null;
}

export interface IssueMedia {
  /** list of storage paths divided by '|' */
  photos: string | null;
  /** list of storage paths */
  attachments: string[];
}

export interface IssueMessage {
  id: string;
  estateId: string;
  defectId: string;
  date: number;
  text: string;
  /** list of storage paths */
  images: string[];
  userId: string;
  userName: string;
  landlordCommunication?: boolean;
}

export interface IssueWebNotifications {
  [issueId: string]: true | null;
}
